import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from '../../../../shared/services';

@Component({
  selector: 'app-similar-fundraiser',
  templateUrl: './similar-fundraiser.component.html',
  styleUrls: ['./similar-fundraiser.component.scss']
})
export class SimilarFundraiserComponent implements OnInit {

  @Input() public fundraisers: any[];
  @Input() public backgroundColor;
  @Input() public title;
  @Input() public slidesPerView = 4;
  @Input() public amount = true;
  @Input() public supporters = true;
  @Input() config;
  @Input() hideRaised;
  currency;
  currencyIcon;
  isMobile: any;
  isSimilarPopupShowed = false;
  breakpoints = {
    600: { perView: 1.1, focusAt: 0 },
    992: { perView: 1, focusAt: 0 }
  };

  constructor(
    public utilService: UtilService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.getCurrency();
  }
  /**CheckLength */
  checkLength() {
    return Array.isArray(this.fundraisers) && this.fundraisers && this.fundraisers.length;
  }

  /**Navigate to the fundraiser */
  goToFundraiser(tag) {
    // this.utilService.navigate('/fundraiser/' + tag);
    this.dialog.closeAll();
  }

  getCurrency() {
    this.utilService.currency.subscribe((res) => {
      if (res) {
        this.currency = res;
        this.currencyIcon = this.utilService.getCurrencyIcon(res);
      }
    });
  }
}
